// Generated from addava.yaml files; do not edit.
import type { SkillPolicy } from '../src/registry';
export const policies: SkillPolicy[] = [
  {
    "version": 1,
    "id": "sf-parcel-discovery",
    "kind": "discovery",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        }
      ],
      "reason": "Resolve a San Francisco address to official parcel identity, building facts, and map coordinates. Use before municipal skills when identifiers or applicability facts are missing."
    },
    "dependencies": [],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 604800,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "identity",
      "attributes"
    ],
    "timeZone": "America/Los_Angeles"
  },
  {
    "version": 1,
    "id": "sf-assessor",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Read San Francisco assessor identity, assessment history, and building facts for a verified parcel."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 604800,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "assessor"
    ]
  },
  {
    "version": 1,
    "id": "sf-dbi",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Collect San Francisco DBI permits, complaints, notices of violation, addenda, and complete case histories."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-assessor",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 3600,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "dbi"
    ],
    "results": [
      {
        "category": "building",
        "noun": [
          "permit",
          "permits"
        ],
        "count": "open"
      },
      {
        "category": "electrical",
        "noun": [
          "permit",
          "permits"
        ],
        "count": "open"
      },
      {
        "category": "plumbing",
        "noun": [
          "permit",
          "permits"
        ],
        "count": "open"
      },
      {
        "category": "complaint",
        "noun": [
          "complaint",
          "complaints"
        ],
        "count": "open"
      },
      {
        "category": "nov",
        "noun": [
          "notice of violation",
          "notices of violation"
        ],
        "count": "open"
      }
    ],
    "capabilities": {
      "timingAdvice": true,
      "hostedBrowser": {
        "navigationOrigins": [
          "https://sanfranciscoca.portal.opengov.com"
        ],
        "timeoutSeconds": 240,
        "maxSessions": 1
      }
    },
    "offers": [
      {
        "id": "resolve-notice",
        "mode": "self-serve",
        "appliesTo": [
          "nov"
        ],
        "verb": "Open the DBI notice",
        "href": "item",
        "steps": "references/resolve-notice.md",
        "completion": {
          "signal": "corrected",
          "window": {
            "days": 60
          }
        }
      },
      {
        "id": "respond-to-complaint",
        "mode": "self-serve",
        "appliesTo": [
          "complaint"
        ],
        "verb": "Open the DBI complaint",
        "href": "item",
        "steps": "references/respond-to-complaint.md",
        "completion": {
          "signal": "closed",
          "window": {
            "days": 60
          }
        }
      },
      {
        "id": "finish-permit",
        "mode": "self-serve",
        "appliesTo": [
          "permit"
        ],
        "verb": "Open the DBI permit",
        "href": "item",
        "steps": "references/finish-permit.md",
        "completion": {
          "signal": "closed",
          "window": {
            "days": 30
          }
        }
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-311",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Read San Francisco 311 cases, current open-case status, and available photos around a property."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 3600,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240,
      "publication": {
        "timezone": "America/Los_Angeles",
        "after": "06:00"
      }
    },
    "outputs": [
      "sf311"
    ],
    "results": [
      {
        "category": "311",
        "noun": [
          "report",
          "reports"
        ],
        "count": "open"
      }
    ],
    "capabilities": {
      "publicProbes": [
        "daily-publication"
      ]
    },
    "offers": [
      {
        "id": "review-report",
        "mode": "self-serve",
        "appliesTo": [
          "311"
        ],
        "verb": "Open the 311 case",
        "href": "item",
        "steps": "references/review-report.md",
        "completion": {
          "signal": "closed",
          "window": {
            "days": 30
          }
        }
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-fire-compliance",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        },
        {
          "field": "isCondo",
          "op": "in",
          "value": [
            true,
            false
          ]
        }
      ],
      "reason": "Read San Francisco fire compliance statements for the verified parcel and, where appropriate, the whole condominium building."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-assessor",
        "required": true
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 21600,
      "freshSeconds": 21600,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "fire-compliance"
    ],
    "results": [
      {
        "category": "fire-compliance",
        "noun": [
          "statement",
          "statements"
        ],
        "count": "newest"
      }
    ],
    "capabilities": {
      "sharedLookups": [
        "sf-safety-scope-v1"
      ]
    },
    "offers": [
      {
        "id": "file-statement",
        "mode": "self-serve",
        "appliesTo": [
          "fire-filing"
        ],
        "verb": "File the statement",
        "href": "https://sf-fire.org/statement-compliance-form-residents-tenants",
        "steps": "references/file-statement.md",
        "completion": {
          "signal": "none"
        },
        "reminders": [
          60,
          30,
          7
        ],
        "leadDays": 90
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-fire-inspections",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        },
        {
          "field": "isCondo",
          "op": "in",
          "value": [
            true,
            false
          ]
        }
      ],
      "reason": "Read San Francisco fire inspections for the verified parcel and, where appropriate, the whole condominium building."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-assessor",
        "required": true
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240,
      "publication": {
        "timezone": "America/Los_Angeles",
        "after": "06:00"
      }
    },
    "outputs": [
      "fire-inspections"
    ],
    "results": [
      {
        "category": "fire-inspection",
        "noun": [
          "inspection",
          "inspections"
        ],
        "count": "newest"
      }
    ],
    "capabilities": {
      "sharedLookups": [
        "sf-safety-scope-v1"
      ]
    },
    "offers": [
      {
        "id": "schedule-reinspection",
        "mode": "self-serve",
        "appliesTo": [
          "fire-inspection"
        ],
        "verb": "Schedule the reinspection",
        "href": "item",
        "steps": "references/schedule-reinspection.md",
        "completion": {
          "signal": "absent",
          "window": {
            "days": 30
          }
        }
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-fire-violations",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        },
        {
          "field": "isCondo",
          "op": "in",
          "value": [
            true,
            false
          ]
        }
      ],
      "reason": "Read San Francisco fire violations for the verified parcel and, where appropriate, the whole condominium building."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-assessor",
        "required": true
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240,
      "publication": {
        "timezone": "America/Los_Angeles",
        "after": "06:00"
      }
    },
    "outputs": [
      "fire-violations"
    ],
    "results": [
      {
        "category": "fire-violation",
        "noun": [
          "violation",
          "violations"
        ],
        "count": "open"
      }
    ],
    "capabilities": {
      "sharedLookups": [
        "sf-safety-scope-v1"
      ]
    },
    "offers": [
      {
        "id": "correct-violation",
        "mode": "self-serve",
        "appliesTo": [
          "fire-violation"
        ],
        "verb": "Correct the violation",
        "href": "item",
        "steps": "references/correct-violation.md",
        "completion": {
          "signal": "closed",
          "window": {
            "days": 30
          }
        }
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-public-works",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Collect San Francisco street-use and utility-excavation records relevant to a property."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240,
      "publication": {
        "timezone": "America/Los_Angeles",
        "after": "06:00"
      }
    },
    "outputs": [
      "public-works"
    ],
    "results": [
      {
        "category": "public-works",
        "noun": [
          "street permit",
          "street permits"
        ],
        "count": "open"
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-recorder",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Read the San Francisco Recorder index and archive available document previews for saved properties."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 21600,
      "freshSeconds": 21600,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "recorder",
      "document-candidates"
    ],
    "results": [
      {
        "category": "recorder",
        "noun": [
          "document",
          "documents"
        ],
        "count": "newest"
      }
    ],
    "capabilities": {
      "credentials": [
        {
          "name": "account",
          "fields": [
            "email",
            "password"
          ]
        }
      ]
    },
    "offers": [
      {
        "id": "clear-lien",
        "mode": "self-serve",
        "appliesTo": [
          "lien"
        ],
        "verb": "Clear the lien",
        "href": "item",
        "steps": "references/clear-lien.md",
        "completion": {
          "signal": "absent",
          "window": {
            "days": 60
          }
        }
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-rent-board",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "displayName": "SF Rent Board",
    "audiences": [
      "saved-property"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Read public San Francisco Rent Board housing inventory submissions and rent-increase licences for the verified parcel."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 300,
      "maxAttempts": 3,
      "timeoutSeconds": 120
    },
    "outputs": [
      "rent-board",
      "document-candidates"
    ],
    "offers": [
      {
        "id": "file-housing-inventory",
        "mode": "self-serve",
        "appliesTo": [
          "skill:sf-rent-board:inventory-filing"
        ],
        "verb": "File on the Rent Board portal",
        "href": "https://portal.sfrb.org/",
        "steps": "references/file-housing-inventory.md",
        "completion": {
          "signal": "closed",
          "window": {
            "days": 14
          }
        },
        "reminders": [
          60,
          30,
          7
        ],
        "leadDays": 90
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-section604",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        },
        {
          "field": "isCondo",
          "op": "in",
          "value": [
            true,
            false
          ]
        }
      ],
      "reason": "Read San Francisco Section 604 affidavits for the verified parcel and, where appropriate, the whole condominium building."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      },
      {
        "skill": "sf-assessor",
        "required": true
      },
      {
        "skill": "sf-dbi",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 604800,
      "freshSeconds": 604800,
      "maxStaleSeconds": 2592000,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "section604"
    ],
    "results": [
      {
        "category": "section604",
        "noun": [
          "affidavit",
          "affidavits"
        ],
        "count": "newest"
      }
    ],
    "capabilities": {
      "sharedLookups": [
        "sf-safety-scope-v1"
      ]
    }
  },
  {
    "version": 1,
    "id": "sf-subdivision",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Collect relevant San Francisco subdivision applications and parcel history."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 21600,
      "freshSeconds": 21600,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "subdivision"
    ],
    "results": [
      {
        "category": "subdivision",
        "noun": [
          "project",
          "projects"
        ],
        "count": "open"
      }
    ]
  },
  {
    "version": 1,
    "id": "sf-treasurer",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Read official San Francisco Treasurer tax accounts, bills, installments, and available bill PDFs."
    },
    "dependencies": [
      {
        "skill": "sf-parcel-discovery",
        "required": false
      }
    ],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "tax-bills",
      "document-candidates"
    ],
    "capabilities": {
      "hostedBrowser": {
        "navigationOrigins": [
          "https://county-taxes.net",
          "https://sanfrancisco-ca.county-taxes.com"
        ],
        "timeoutSeconds": 240,
        "maxSessions": 1
      }
    },
    "offers": [
      {
        "id": "pay-installment",
        "mode": "self-serve",
        "appliesTo": [
          "tax"
        ],
        "verb": "Pay on the Treasurer site",
        "href": "item",
        "steps": "references/pay-installment.md",
        "completion": {
          "signal": "closed",
          "window": {
            "businessDays": 10
          }
        },
        "reminders": [
          30,
          10,
          1
        ],
        "leadDays": 90
      }
    ]
  },
  {
    "version": 1,
    "id": "us-street-view",
    "kind": "source",
    "legacyCollectionVersion": "1",
    "collectionVersion": "1",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "inputs",
      "documentContents": false,
      "exactInputVersions": true
    },
    "entrypoint": "scripts/collect.ts",
    "runtime": "scripts/runtime.ts",
    "fieldMeanings": "scripts/field-meanings.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "latitude",
          "op": "exists"
        },
        {
          "field": "longitude",
          "op": "exists"
        }
      ],
      "reason": "Find available Street View panoramas and capture history for a US property with verified coordinates."
    },
    "dependencies": [],
    "monitoring": {
      "triggers": [
        "save",
        "scheduled",
        "facts-changed",
        "manual"
      ],
      "intervalSeconds": 2592000,
      "freshSeconds": 2592000,
      "maxStaleSeconds": 7776000,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "street-view"
    ],
    "capabilities": {
      "geographicSignals": true
    }
  },
  {
    "version": 1,
    "id": "notification-summary",
    "kind": "analysis",
    "audiences": [
      "saved-property"
    ],
    "readiness": {
      "after": "accepted-changes",
      "documentContents": false,
      "exactInputVersions": true
    },
    "analysisEntrypoint": "scripts/analysis.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        }
      ],
      "reason": "Write concise property-change notification prose from accepted, versioned change events."
    },
    "dependencies": [],
    "monitoring": {
      "triggers": [
        "sources-changed",
        "facts-changed"
      ],
      "intervalSeconds": 3600,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "notification-prose"
    ]
  },
  {
    "version": 1,
    "id": "property-case-analysis",
    "kind": "analysis",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "applicable-sources",
      "documentContents": true,
      "exactInputVersions": true
    },
    "analysisEntrypoint": "scripts/analysis.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        }
      ],
      "reason": "Analyze related property records after all applicable source branches and required document contents have settled."
    },
    "dependencies": [],
    "monitoring": {
      "triggers": [
        "sources-changed",
        "facts-changed"
      ],
      "intervalSeconds": 3600,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "relationships",
      "case-stories",
      "lien-matches"
    ]
  },
  {
    "version": 1,
    "id": "property-record-summary",
    "kind": "analysis",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "source-record",
      "documentContents": true,
      "exactInputVersions": true
    },
    "analysisEntrypoint": "scripts/analysis.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        }
      ],
      "reason": "Summarize a fully fetched property record using its original details and cited evidence."
    },
    "dependencies": [],
    "monitoring": {
      "triggers": [
        "sources-changed",
        "facts-changed"
      ],
      "intervalSeconds": 3600,
      "freshSeconds": 3600,
      "maxStaleSeconds": 86400,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "record-summaries"
    ]
  },
  {
    "version": 1,
    "id": "sf-fire-filing-review",
    "kind": "analysis",
    "audiences": [
      "saved-property",
      "public-preview"
    ],
    "readiness": {
      "after": "applicable-sources",
      "documentContents": true,
      "exactInputVersions": true
    },
    "analysisEntrypoint": "scripts/analysis.ts",
    "applicability": {
      "all": [
        {
          "field": "country",
          "op": "eq",
          "value": "US"
        },
        {
          "field": "region",
          "op": "eq",
          "value": "CA"
        },
        {
          "field": "city",
          "op": "eq",
          "value": "San Francisco"
        },
        {
          "field": "block",
          "op": "exists"
        },
        {
          "field": "lot",
          "op": "exists"
        }
      ],
      "reason": "Review whether an existing San Francisco fire compliance statement appears current under the two-year filing cycle."
    },
    "dependencies": [
      {
        "skill": "sf-assessor",
        "required": true
      },
      {
        "skill": "sf-fire-compliance",
        "required": true
      }
    ],
    "monitoring": {
      "triggers": [
        "sources-changed",
        "facts-changed"
      ],
      "intervalSeconds": 86400,
      "freshSeconds": 86400,
      "maxStaleSeconds": 259200,
      "retrySeconds": 60,
      "maxAttempts": 3,
      "timeoutSeconds": 240
    },
    "outputs": [
      "fire-filing-review"
    ]
  }
];
